import * as React from "react";

import { cn } from "@/lib/utils";
import { FluentIcon } from "@fluentui/react-icons";

export interface InputWithIconProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  Icon: FluentIcon;
}

const InputWithIcon = React.forwardRef<HTMLInputElement, InputWithIconProps>(
  ({ Icon, ...props }, ref) => {
    return (
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <Icon fontSize={20} className="text-gray-400" aria-hidden="true" />
        </div>
        <Input className="pl-10 pr-3" ref={ref} {...props} />
      </div>
    );
  },
);

export interface InputWithActionProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  action: {
    Icon: any;
    onClick: () => void;
  };
}

const InputWithAction = React.forwardRef<
  HTMLInputElement,
  InputWithActionProps
>(({ action, ...props }, ref) => {
  const Icon = action.Icon;
  return (
    <div className="relative">
      <Input className="pl-3 pr-10" ref={ref} {...props} />
      <div
        role="button"
        onClick={() => action.onClick()}
        className="pointer-events-auto absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <Icon className="h-5 w-5 text-gray-400" aria-hidden="true" />
      </div>
    </div>
  );
});

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "file: flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[0.5px] focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

InputWithIcon.displayName = "InputWithIcon";
InputWithAction.displayName = "InputWithAction";
Input.displayName = "Input";

export { Input, InputWithAction, InputWithIcon };
